import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Component } from "preact";
import { Button, Table } from "react-bootstrap";
import IBA from "../../lib/iba";
import { formatDateFr, getAgeFromDate } from "../../lib/utils";

export default class CustomerCard extends Component {
    render(props) {
        const customer = props.customer;

        return (
            <>
                <Table responsive striped hover className={"mb-0"}>
                    <tbody>
                        {!this.props.short ? <tr>
                            <th>IBA ID</th>
                            <td>
                                <a target="_blank" href={IBA.linkToCustomer(customer.external_id)}>
                                    {customer.external_id}
                                </a>
                            </td>
                        </tr> : null}
                        {this.props.short ? <tr>
                            <td colSpan={2}>
                                <Button className={`w-100`} variant="outline-primary" size="sm" onClick={() => {
                                    return window.open(`/customers/${customer.id}`, '_blank');
                                }}>
                                    <FontAwesomeIcon icon={faUser} />
                                    Voir la fiche
                                </Button>
                            </td>
                        </tr> : null}
                        <tr>
                            <th>Nom</th>
                            <td>{customer.lastname}</td>
                        </tr>
                        <tr>
                            <th>Prénom</th>
                            <td>{customer.firstname}</td>
                        </tr>
                        <tr>
                            <th>Tel. portable</th>
                            <td>
                                <a href={`tel:${customer.mobile_phone}`}>{customer.mobile_phone}</a>
                            </td>
                        </tr>
                        <tr>
                            <th>Email</th>
                            <td>
                                <a href={`mailto:${customer.primary_email}`}>{customer.primary_email}</a>
                            </td>
                        </tr>
                        {!this.props.short ? <tr>
                            <th>Adresse</th>
                            <td>{customer.address}</td>
                        </tr> : null}
                        <tr>
                            <th>Code postal</th>
                            <td>{customer.postal_code}</td>
                        </tr>
                        <tr>
                            <th>Ville</th>
                            <td>{customer.city}</td>
                        </tr>
                        <tr>
                            <th>{this.props.short ? 'DDN' : 'Date de naissance'}</th>
                            <td>{formatDateFr(customer.birthdate)} ({getAgeFromDate(customer.birthdate)})</td>
                        </tr>
                    </tbody>
                </Table>
            </>
        );
    }
}
